"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const prop_types_1 = require("prop-types");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledButton = styled_components_1.default.button `
  cursor: pointer;
  text-align: center;
  height: 48px;
  width: ${(props) => ((props === null || props === void 0 ? void 0 : props.fullWidth) ? "100%" : "auto")};

  padding: 0 24px 0 24px;
  box-sizing: border-box;
  border: ${(props) => {
    var _a, _b;
    switch (props === null || props === void 0 ? void 0 : props.variant) {
        case "secondary":
            return `2px solid ${(_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.colours) === null || _b === void 0 ? void 0 : _b.purple}`;
        default:
            return "none";
    }
}};
  background: ${(props) => {
    var _a, _b, _c, _d, _e, _f;
    switch (props === null || props === void 0 ? void 0 : props.variant) {
        case "primary":
            return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.gradients) === null || _b === void 0 ? void 0 : _b.purpleToPink;
        case "secondary":
            return (_d = (_c = props === null || props === void 0 ? void 0 : props.theme) === null || _c === void 0 ? void 0 : _c.colours) === null || _d === void 0 ? void 0 : _d.white;
        case "tertiary":
            return (_f = (_e = props === null || props === void 0 ? void 0 : props.theme) === null || _e === void 0 ? void 0 : _e.colours) === null || _f === void 0 ? void 0 : _f.white;
        default:
            return "unset";
    }
}};

  color: ${(props) => {
    var _a, _b, _c, _d;
    switch (props === null || props === void 0 ? void 0 : props.variant) {
        case "primary":
            return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.colours) === null || _b === void 0 ? void 0 : _b.white;
        default:
            return (_d = (_c = props === null || props === void 0 ? void 0 : props.theme) === null || _c === void 0 ? void 0 : _c.colours) === null || _d === void 0 ? void 0 : _d.purple;
    }
}};
  font-weight: 500;
  border-radius: 24px;
  box-shadow: ${(props) => {
    var _a, _b, _c, _d, _e, _f;
    switch (props === null || props === void 0 ? void 0 : props.variant) {
        case "primary":
            return `0 2px 8px 0 ${(_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.colours) === null || _b === void 0 ? void 0 : _b.pink}66`;
        case "secondary":
            return `0 2px 8px 0 ${(_d = (_c = props === null || props === void 0 ? void 0 : props.theme) === null || _c === void 0 ? void 0 : _c.colours) === null || _d === void 0 ? void 0 : _d.pink}66`;
        case "tertiary":
            return `0 2px 8px 0 ${(_f = (_e = props === null || props === void 0 ? void 0 : props.theme) === null || _e === void 0 ? void 0 : _e.colours) === null || _f === void 0 ? void 0 : _f.pink}66`;
        default:
            return false;
    }
}};

  line-height: 1;
  &:disabled {
    opacity: 0.3;
  }
  :hover {
    background: ${(props) => {
    var _a, _b;
    switch (props === null || props === void 0 ? void 0 : props.variant) {
        case "primary":
            return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.gradients) === null || _b === void 0 ? void 0 : _b.purpleToPinkLight;
        default:
            return false;
    }
}};
    color: ${(props) => {
    var _a, _b, _c, _d;
    switch (props === null || props === void 0 ? void 0 : props.variant) {
        case "primary":
            return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.colours) === null || _b === void 0 ? void 0 : _b.white;
        default:
            return (_d = (_c = props === null || props === void 0 ? void 0 : props.theme) === null || _c === void 0 ? void 0 : _c.colours) === null || _d === void 0 ? void 0 : _d.pink;
    }
}};
  }

  position: relative;
`;
const ButtonContent = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) => props.justIcon &&
    `
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  `}
`;
const ButtonIcon = styled_components_1.default.span `
  > svg {
    font-size: 1.5em;
  }
`;
const ButtonText = styled_components_1.default.span `
  margin-left: ${(props) => (props === null || props === void 0 ? void 0 : props.startIcon) && "8px"};
  margin-right: ${(props) => (props === null || props === void 0 ? void 0 : props.endIcon) && "8px"};
`;
function Button(_a) {
    var { className, text, primary, secondary, tertiary, disabled, onClick, startIcon, endIcon, fullWidth } = _a, rest = __rest(_a, ["className", "text", "primary", "secondary", "tertiary", "disabled", "onClick", "startIcon", "endIcon", "fullWidth"]);
    const variant = primary
        ? "primary"
        : secondary
            ? "secondary"
            : tertiary
                ? "tertiary"
                : "";
    return (react_1.default.createElement(StyledButton, Object.assign({ className: className, variant: variant, disabled: disabled, onClick: onClick, fullWidth: fullWidth }, rest),
        react_1.default.createElement(ButtonContent, { justIcon: !text && ((startIcon && !endIcon) || (!startIcon && endIcon)) },
            startIcon && react_1.default.createElement(ButtonIcon, null, startIcon),
            text && (react_1.default.createElement(ButtonText, { startIcon: startIcon, endIcon: endIcon }, text)),
            endIcon && react_1.default.createElement(ButtonIcon, null, endIcon))));
}
exports.Button = Button;
Button.propTypes = {
    onClick: prop_types_1.func.isRequired,
    className: prop_types_1.string,
    text: prop_types_1.string,
    primary: prop_types_1.bool,
    secondary: prop_types_1.bool,
    tertiary: prop_types_1.bool,
    disabled: prop_types_1.bool,
    icon: prop_types_1.element,
};
//# sourceMappingURL=button.js.map